import { FileUploadStatus } from '../enums';
function cancelFileUpload(state, id) {
    return Object.assign(Object.assign({}, state), { byId: Object.assign(Object.assign({}, state.byId), { [id]: Object.assign(Object.assign({}, state.byId[id]), { uploadStatus: FileUploadStatus.CANCELLED }) }) });
}
export const singleFileUploadCancelReducer = (state, action) => {
    var _a;
    let newState = cancelFileUpload(state, action.payload.id);
    const thumbnailId = (_a = state.allIds.map(id => state.byId[id]).find(fileInfo => fileInfo.parentId === action.payload.id)) === null || _a === void 0 ? void 0 : _a.id;
    if (thumbnailId) {
        newState = cancelFileUpload(newState, thumbnailId);
    }
    return newState;
};
//# sourceMappingURL=singleFileUploadCancelReducer.js.map